import * as types from './types';
import { loading } from 'State/actions';
import { toastError } from 'Common/ToastHelper';

export const initialize = () => async dispatch => {
  dispatch(loading(types.CLOSE_SCHOOL_YEAR_INITIALIZING, true));

  try {
    await dispatch(getFiscalYear());
  } catch (error) {
    toastError('There was an error initialiazing Close School Year.');
  }

  dispatch(loading(types.CLOSE_SCHOOL_YEAR_INITIALIZING, false));
};

export const getFiscalYear = () => async (dispatch, getState, MPWWebApi) => {
  try {
    const response = await MPWWebApi.getGeneric(
      `closeSchoolYear/getCurrentFiscalYear`
    );

    dispatch({
      type: types.CLOSE_SCHOOL_YEAR_SET_FISCAL_YEAR,
      payload: response.data.Data,
    });
  } catch (error) {
    toastError('There was an error getting the fiscal year.');
  }
};

export const getUnclosedDates = () => async (dispatch, getState, MPWWebApi) => {
  try {
    const response = await MPWWebApi.getGeneric(
      `closeSchoolYear/getUnclosedDates`
    );

    dispatch({
      type: types.CLOSE_SCHOOL_YEAR_SET_UNCLOSED_DATES,
      payload: response.data.Data,
    });
  } catch (error) {
    toastError('There was an error getting the unclosed days.');
  }
};



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/state/actions.js